import { DateTime } from "luxon";
import * as React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { VscChevronDown } from "react-icons/vsc";

import "./DateRangeSelect.scss";

interface DateRangeSelectProps {
  startDate: Date;
  endDate: Date;
  datePicked(isStart: boolean, date?: Date): void;
}
interface DateRangeSelectState {
  showingStartPicker: boolean;
  showingEndPicker: boolean;
}
export class DateRangeSelect extends React.Component<DateRangeSelectProps, DateRangeSelectState> {
  constructor(props) {
    super(props);
    this.state = { showingStartPicker: false, showingEndPicker: false };
    this.onStartChange = this.onStartChange.bind(this);
    this.onEndChange = this.onEndChange.bind(this);
    this.startDateClicked = this.startDateClicked.bind(this);
    this.endDateClicked = this.endDateClicked.bind(this);
    this.renderStartPicker = this.renderStartPicker.bind(this);
    this.renderEndPicker = this.renderEndPicker.bind(this);
  }
  onStartChange(date) {
    this.props.datePicked(true, date);
  }
  onEndChange(date) {
    this.props.datePicked(false, date);
  }

  startDateClicked() {
    this.setState({ showingStartPicker: !this.state.showingStartPicker, showingEndPicker: false });
  }
  endDateClicked() {
    this.setState({ showingStartPicker: false, showingEndPicker: !this.state.showingEndPicker });
  }

  renderStartPicker() {
    if (!this.state.showingStartPicker) {
      return null;
    }
    return (
      <div className="pickerWrapper">
        <DatePicker selected={this.props.startDate} onChange={this.onStartChange} maxDate={this.props.endDate} dateFormat="MMM d, yyyy" />
      </div>
    );
  }
  renderEndPicker() {
    if (!this.state.showingEndPicker) {
      return null;
    }
    return (
      <div className="pickerWrapper">
        <DatePicker selected={this.props.endDate} onChange={this.onEndChange} maxDate={new Date()} minDate={this.props.startDate} />
      </div>
    );
  }

  renderButton(date, showing, clickFunc) {
    const className = showing ? "pickerButtonWrapper showing" : "pickerButtonWrapper";
    return (
      <div className={className} onClick={clickFunc}>
        <div className="pickerButton">
          <div className="pickerText">{DateTime.fromJSDate(date).toLocaleString(DateTime.DATE_MED)}</div>
          <div className="pickerChevron">
            <VscChevronDown />
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="DateRangeSelect">
        <DatePicker
          selected={this.props.startDate}
          onChange={this.onStartChange}
          maxDate={this.props.endDate}
          dateFormat="MMM d, yyyy"
          customInput={this.renderButton(this.props.startDate, this.state.showingStartPicker, this.startDateClicked)}
        />

        <DatePicker
          selected={this.props.endDate}
          onChange={this.onEndChange}
          maxDate={new Date()}
          minDate={this.props.startDate}
          customInput={this.renderButton(this.props.endDate, this.state.showingEndPicker, this.endDateClicked)}
        />
      </div>
    );
  }
}
